module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.$t('culture_function_menu')))]), _vm._v(" "), _c('div', {
    staticClass: "my-5 list-box",
    staticStyle: {
      "min-height": "40vh"
    }
  }, [_c('div', {
    staticClass: "menu-box",
    on: {
      "click": function($event) {
        return _vm.goPage('option')
      }
    }
  }, [(_vm.$i18n.locale === 'tw') ? _c('div', [_c('p', [_vm._v("開始上課")]), _vm._v(" "), _c('p', [_vm._v("Start a new course")])]) : _c('p', [_vm._v(" " + _vm._s(_vm.$t('start_course')))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-box",
    on: {
      "click": _vm.goRecord
    }
  }, [(this.$i18n.locale === 'tw') ? _c('div', [_c('p', [_vm._v("觀看使用紀錄")]), _vm._v(" "), _c('p', [_vm._v("Using a record")])]) : _c('p', [_vm._v(" " + _vm._s(_vm.$t('using_record')))])])]), _vm._v(" "), _c('div', {
    staticClass: "download-box px-4"
  }, [_c('a', {
    staticClass: "downloadLink",
    attrs: {
      "download": "LiveCampus 使用手冊",
      "href": _vm.sampleFile
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('download_instructions')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22c7b4c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/ar/ARIndex.vue
// module id = 762
// module chunks = 3